import router from '@/router'
import NProgress from 'nprogress' // progress bar
import '@/components/styles/nprogress.less'
import { setDocumentTitle } from '@/utils'
import defaultConfig from '@/config/default.config'
import store from '@/store'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

NProgress.configure({ showSpinner: false })

// 白名单，不需要验证
const whiteList = [
  'manage-login',
  'manage-regist',
  'manage-m-login'
]

router.beforeEach((to, from, next) => {
  NProgress.start()
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${defaultConfig.title}`))

  if (storage.get(ACCESS_TOKEN)) {
    if (to.name === 'manage-login') {
      next({ name: 'manage' })
    } else {
      if (store.state.user.menus.length === 0) {
        store.dispatch('GetInfo').then((res) => {
          store.dispatch('GetMenus').then(menus => {
            store.dispatch('GenerateRoutes', { menus }).then(routes => {
              routes.map(e => {
                router.addRoute(e)
              })
              console.log(2222222)
              next({ ...to, replace: true })
            })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      if (to.path.indexOf('/m/') > 0) {
        next({ name: 'manage-m-login' })
      } else {
        next({ name: 'manage-login' })
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
